import type { SearchFilterApi } from '@ingenico/api-sdk-provisioning-public';
import { searchOperator, searchRequestSortOrder } from '@ingenico/api-sdk-provisioning-public';
import { useBusinessServiceRequest } from '@ingenico/react-section-utils';
import { toString } from 'lodash-es';
import { useCallback, useMemo, useState } from 'react';
import { DeviceManagementService } from '../domain/business/services/deviceManagement.service';

type DevicesFilterField = 'merchant.id' | 'store.id';

export function useDevicesQuery(entityId?: string, filterField: DevicesFilterField = 'merchant.id', enabled = true) {
  const filters = useMemo<SearchFilterApi[]>(
    () => [
      {
        filterType: 'string',
        name: filterField,
        operator: searchOperator.equals,
        value: toString(entityId),
      },
    ],
    [entityId, filterField],
  );
  const [sort] = useState({ field: 'logicalDevice.name', order: searchRequestSortOrder.ASC });

  const {
    data: devicesData,
    isLoading: isDevicesLoading,
    isError: isDevicesError,
    refetch: refetchDevice,
  } = useBusinessServiceRequest(
    DeviceManagementService,
    useCallback(
      (deviceManagementService, isRefetch) =>
        enabled && entityId ? deviceManagementService.getBffLogicalDeviceList(filters, sort, isRefetch) : null,
      [enabled, entityId, filters, sort],
    ),
  );

  return { devicesData, isDevicesLoading, isDevicesError, refetchDevice };
}
